import { render, staticRenderFns } from "./LayoutNav.vue?vue&type=template&id=0b4c1d73&scoped=true"
import script from "./LayoutNav.vue?vue&type=script&lang=js"
export * from "./LayoutNav.vue?vue&type=script&lang=js"
import style0 from "./LayoutNav.vue?vue&type=style&index=0&id=0b4c1d73&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4c1d73",
  null
  
)

export default component.exports